'use client';

import { CloseButton, Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { Close } from 'components/gruenland/icons/Close';
import { StoreLocator } from './StoreLocator';

type Props = {
  onClose: () => void;
  open: boolean;
  productId?: string;
};

const StoreLocatorModal: React.FC<Props> = ({ onClose, open, productId }) => (
  <Dialog className="relative z-50" onClose={onClose} open={open}>
    <DialogBackdrop className="fixed inset-0 bg-[#7f7f7f]/30" />
    <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
      <DialogPanel className="relative w-full space-y-4 rounded-md border bg-white p-12 md:w-5/6">
        <CloseButton className="absolute right-2 top-2 p-[3px]">
          <Close />
        </CloseButton>
        <StoreLocator productId={productId} />
      </DialogPanel>
    </div>
  </Dialog>
);

export default StoreLocatorModal;
